import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IPhxStateService } from 'utility-ng-configuration';
import { RouterHelper } from '../../../global/helpers/router_helper';
import { APChangelogQuery } from '../../queries/ap_changelog_query';
import { APAdvisorText } from './../../../global/servants/ap_advisor_text_servant';

class Changelog {
  private query: APChangelogQuery;
  private showLoading: boolean;
  private advisorText: string;

  constructor(
    private loadChangelogCommand: ICommand,
    private routerHelper: RouterHelper,
    private $state: IPhxStateService,
    private ngAPChangelogQuery: APChangelogQuery,
    private ngAPAdvisorText: APAdvisorText,
    private appConfigModel: any,
    private phxFeatureConfiguration: any
  ) {
    this.showLoading = true;
    this.query = ngAPChangelogQuery;
  }

  $onInit() {
    this.loadChangelog();
    this.advisorText = this.ngAPAdvisorText.advisorLabel;
  }

  loadChangelog() {
    this.loadChangelogCommand().then(() => {
      this.showLoading = false;
    });
  }

  print() {
    window.print();
  }
  getInitials(sender_info: any) {
    const firstName = _4.get(sender_info, 'first_name', '');
    const lastName = _4.get(sender_info, 'last_name', '');
    if (_4.isEmpty(firstName) || _4.isEmpty(lastName)) {
      return '';
    }
    return `${_4.upperCase(_4.first(firstName))} ${_4.upperCase(_4.first(lastName))}`;
  }

  isAp3FeatureEnabled() {
    return this.appConfigModel.isFeatureEnabled('ap3-academic_planner_v3');
  }

  goBack() {
    if (this.isAp3FeatureEnabled()) {
      window.location.assign('#/my/ap3/student/');
      return;
    }
    if (this.$state.__previousRoute__.state.name !== '') {
      return this.$state.__goToPrevious__();
    }

    return this.routerHelper.findStateAndGo('.default');
  }
}

angular.module('capability-ng-academic-planner').component('changelog', {
  templateUrl: 'capability-ng-academic-planner/src/changelog/components/changelog/changelog.html',
  controller: Changelog
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/changelog/components/changelog/changelog.ts